<!-- EventSignup.vue — อีเวนต์/แข่งขัน ฝั่งผู้ปกครอง (EVENT_SYSTEM_DESIGN.md §7.3 เฟส 4)
  วางอยู่ในหน้าแรกของผู้ปกครอง (Home.vue) ไม่ใช่เมนูใหม่ — ผู้ปกครองไม่ต้องรู้ว่ามีหน้า "อีเวนต์"
  ทั้งบล็อกซ่อนตัวเองเมื่อไม่มีอีเวนต์เปิดรับสมัครและไม่มีใบสมัครของครอบครัวเลย (ไม่กินที่หน้าจอเปล่า ๆ)

  กติกาที่หน้าจอนี้ต้องสะท้อนให้ตรงกับ backend (ห้ามเดาเอง):
   • ราคา **ระบบคำนวณ** ผู้ปกครองแก้ไม่ได้ · ยอดที่เห็น = ยิม + ผู้จัด รวมเป็นยอดเดียว (§7.7)
   • ลูกที่คิดราคาไม่ได้ / คนละโปรแกรม → ติ๊กไม่ได้ + บอกเหตุผล (ไม่ใช่ปุ่มเทาเงียบ ๆ)
   • **โอนเท่านั้น** — แนบสลิปตอนสมัคร หรือ "ชำระทีหลัง" ได้ถึงวันปิดรับสมัคร
   • 1 สลิปครอบทุกใบค้างของครอบครัวในอีเวนต์นั้น (จ่ายรวมหลายลูก)
   • ยกเลิกเองได้เฉพาะใบที่ยังไม่จ่าย · จ่ายแล้วต้องติดต่อแอดมิน -->
<template>
  <div v-if="loading || openEvents.length || myRegs.length">
    <!-- ══ อีเวนต์ที่เปิดรับสมัคร ══ -->
    <template v-if="loading || openEvents.length">
      <div class="isk-sec" style="margin:24px 0 10px">
        <span class="mdi mdi-trophy-outline"></span> {{ $t('evSignup.openTitle') }}
      </div>
      <div v-if="loading" class="scard" style="padding:0">
        <div v-for="i in 2" :key="'esk' + i" class="ev-row">
          <div class="id-skel" style="width:54px;height:48px;border-radius:10px;flex:0 0 54px"></div>
          <div class="col" style="gap:6px;flex:1">
            <div class="id-skel" style="height:13px;width:50%"></div>
            <div class="id-skel" style="height:11px;width:32%"></div>
          </div>
        </div>
      </div>
      <div v-else class="ev-cards id-fade-in" :key="'evc' + openEvents.length">
        <div v-for="ev in openEvents" :key="ev.eventid" class="scard ev-card">
          <div class="ev-card-head">
            <div class="ev-date">
              <span class="ev-date-d">{{ dateBadge(ev.eventdate).d }}</span>
              <span class="ev-date-m">{{ dateBadge(ev.eventdate).m }}</span>
            </div>
            <div class="ev-card-main">
              <div class="strong">{{ ev.eventname }}</div>
              <div class="t-cap">
                <span class="mdi mdi-calendar"></span> {{ $formatShortDate(ev.eventdate) }}
                <template v-if="ev.starttime"> · {{ ev.starttime }}</template>
                <template v-if="ev.coursename"> · {{ ev.coursename }}</template>
              </div>
              <div v-if="ev.reg_close" class="t-cap">
                <span class="mdi mdi-clock-alert-outline"></span>
                {{ $t('evSignup.payBy', { date: $formatShortDate(ev.reg_close) }) }}
              </div>
            </div>
            <span class="badge" :class="ev.seatsLeft > 0 ? 'badge-neutral' : 'badge-warning'">
              {{ ev.seatsLeft > 0 ? $t('evSignup.seatsLeft', { n: ev.seatsLeft }) : $t('evSignup.full') }}
            </span>
          </div>
          <div v-if="ev.note" class="t-cap ev-note">{{ ev.note }}</div>
          <div class="t-cap ev-price">
            <span class="mdi mdi-cash"></span>
            <template v-if="cheapest(ev) === null">{{ $t('evSignup.priceAskAdmin') }}</template>
            <template v-else-if="Number(cheapest(ev)) === 0">{{ $t('evSignup.free') }}</template>
            <template v-else>{{ $t('evSignup.perPerson', { amount: $money(cheapest(ev)) }) }}</template>
          </div>
          <button class="id-btn id-btn-primary" style="width:100%;margin-top:10px"
            :disabled="!canSignup(ev)" @click="openSignup(ev)">
            <span class="mdi mdi-account-plus"></span> {{ $t('evSignup.signupBtn') }}
          </button>
          <div v-if="!canSignup(ev)" class="fhint" style="margin-top:6px">{{ blockReason(ev) }}</div>
        </div>
      </div>
    </template>

    <!-- ══ การสมัครของฉัน ══ -->
    <template v-if="myRegs.length">
      <div class="isk-sec" style="margin:24px 0 10px">
        <span class="mdi mdi-clipboard-check-outline"></span> {{ $t('evSignup.mineTitle') }}
      </div>
      <div class="scard" style="padding:0">
        <div v-for="r in myRegs" :key="r.registrationid" class="ev-row">
          <div class="ev-date">
            <span class="ev-date-d">{{ dateBadge(r.eventdate).d }}</span>
            <span class="ev-date-m">{{ dateBadge(r.eventdate).m }}</span>
          </div>
          <div class="ev-row-main">
            <div class="strong ev-wrap">{{ r.eventname }}</div>
            <div class="t-cap"><span class="mdi mdi-account"></span> {{ r.nickname }} · {{ $baht(regTotal(r)) }}</div>
            <div v-if="needsPay(r) && r.reg_close" class="t-cap">
              <span class="mdi mdi-clock-alert-outline"></span> {{ $t('evSignup.payBy', { date: $formatShortDate(r.reg_close) }) }}
            </div>
          </div>
          <div class="ev-row-side">
            <span v-if="r.checkedin" class="badge badge-success">{{ $t('evSignup.checkedin') }}</span>
            <span v-else-if="r.paid" class="badge badge-success">{{ $t('evSignup.paid') }}</span>
            <span v-else-if="needsPay(r)" class="badge badge-warning">{{ $t('evSignup.unpaid') }}</span>
            <div v-if="needsPay(r)" class="ev-row-actions">
              <button class="id-btn id-btn-ghost id-btn-sm" @click="openPay(r)">
                <span class="mdi mdi-upload"></span> {{ $t('evSignup.uploadSlip') }}
              </button>
              <button class="id-btn id-btn-ghost id-btn-sm ev-btn-danger" @click="askCancel(r)">
                <span class="mdi mdi-close"></span> {{ $t('btn.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ══ dialog สมัคร ══ -->
    <id-modal v-model="signupDlg" size="lg" icon="mdi-trophy-outline"
      :title="$t('evSignup.dialogTitle')" :subtitle="cur ? cur.eventname : ''" persistent>
      <template v-if="cur">
        <div class="modal-sec"><span class="mdi mdi-account-multiple"></span> {{ $t('evSignup.pickChildren') }}</div>
        <div v-for="c in cur.children" :key="c.studentid" class="ev-pick"
          :class="{ 'ev-pick-off': !pickable(c) }" @click="togglePick(c)">
          <span class="id-check" :class="{ on: picked.includes(c.studentid) }"><span class="mdi mdi-check"></span></span>
          <div style="flex:1;min-width:0">
            <div class="strong">{{ c.nickname }}</div>
            <div class="t-cap" v-if="c.alreadyRegistered">{{ c.alreadyPaid ? $t('evSignup.alreadyPaid') : $t('evSignup.alreadyRegistered') }}</div>
            <div class="t-cap" v-else-if="c.programBlocked">{{ $t('evSignup.programBlocked') }}</div>
            <div class="t-cap" v-else-if="c.needAdmin">{{ $t('evSignup.needAdmin') }}</div>
          </div>
          <span class="ev-pick-fee" v-if="c.price">{{ Number(c.price.total) === 0 ? $t('evSignup.free') : $baht(c.price.total) }}</span>
        </div>

        <div class="modal-sec mt"><span class="mdi mdi-cash-multiple"></span> {{ $t('evSignup.payment') }}</div>
        <div class="row" style="justify-content:space-between;font-size:15px;font-weight:700">
          <span>{{ $t('evSignup.total') }}</span><span>{{ $baht(pickedTotal) }}</span>
        </div>
        <!-- โอนอย่างเดียวโดยตั้งใจ (§7.6): ไม่มีเงินสด/บัตรในช่องทางของผู้ปกครอง -->
        <div class="fhint" style="margin-top:4px">{{ $t('evSignup.transferOnly') }}</div>
        <div v-if="pickedTotal > 0" class="field full" style="margin-top:10px">
          <label>{{ $t('evSignup.slipOptional') }}</label>
          <!-- แพทเทิร์นเดียวกับหน้าคอร์ส/Private: input ซ่อนไว้ใต้ label .id-upload — ใส่คลาสบน
               <input type=file> ตรง ๆ ไม่ได้ เบราว์เซอร์จะวาดปุ่ม "เลือกไฟล์" ของ OS ทับธีมทั้งช่อง -->
          <label class="id-upload">
            <span class="mdi mdi-camera-outline"></span>
            <span class="ev-upload-name">{{ file ? file.name : $t('evSignup.pickSlipFile') }}</span>
            <input type="file" accept="image/*" hidden @change="onFile">
          </label>
          <div class="fhint">{{ $t('evSignup.slipLaterHint') }}</div>
        </div>
      </template>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="signupDlg = false">{{ $t('btn.cancel') }}</button>
        <button class="id-btn id-btn-primary" :disabled="!picked.length || saving" @click="submitSignup">
          <span class="mdi mdi-content-save"></span> {{ $t('evSignup.confirmSignup') }}
        </button>
      </template>
    </id-modal>

    <!-- ══ dialog แนบสลิปทีหลัง (ครอบทุกใบค้างของอีเวนต์นั้น) ══ -->
    <id-modal v-model="payDlg" size="md" icon="mdi-upload" :title="$t('evSignup.uploadSlipTitle')"
      :subtitle="payTarget ? payTarget.eventname : ''" persistent>
      <template v-if="payTarget">
        <div class="row" style="justify-content:space-between;font-size:15px;font-weight:700">
          <span>{{ $t('evSignup.totalDue') }}</span><span>{{ $baht(dueOfEvent(payTarget.eventid)) }}</span>
        </div>
        <div class="fhint" style="margin-top:4px">
          {{ $t('evSignup.coversAll', { names: pendingNames(payTarget.eventid) }) }}
        </div>
        <div class="field full" style="margin-top:12px">
          <label>{{ $t('evSignup.slip') }} <span class="req">*</span></label>
          <label class="id-upload">
            <span class="mdi mdi-camera-outline"></span>
            <span class="ev-upload-name">{{ file ? file.name : $t('evSignup.pickSlipFile') }}</span>
            <input type="file" accept="image/*" hidden @change="onFile">
          </label>
        </div>
      </template>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="payDlg = false">{{ $t('btn.cancel') }}</button>
        <button class="id-btn id-btn-primary" :disabled="!file || saving" @click="submitSlip">
          <span class="mdi mdi-upload"></span> {{ $t('evSignup.sendSlip') }}
        </button>
      </template>
    </id-modal>

    <!-- ══ ยืนยันยกเลิก ══ -->
    <id-modal v-model="cancelDlg" size="sm" icon="mdi-alert-outline" :title="$t('evSignup.cancelTitle')">
      <div v-if="cancelTarget">
        {{ $t('evSignup.cancelConfirm', { name: cancelTarget.nickname, event: cancelTarget.eventname }) }}
      </div>
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="cancelDlg = false">{{ $t('btn.close') }}</button>
        <button class="id-btn id-btn-primary" style="background:var(--c-error)" :disabled="saving" @click="submitCancel">
          <span class="mdi mdi-close"></span> {{ $t('evSignup.cancelBtn') }}
        </button>
      </template>
    </id-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { monthShortNames } from '@/utils/locale';

export default {
  name: 'EventSignup',
  data() {
    return {
      loading: true, saving: false,
      openEvents: [], myRegs: [],
      signupDlg: false, cur: null, picked: [], file: null,
      payDlg: false, payTarget: null,
      cancelDlg: false, cancelTarget: null,
    };
  },
  computed: {
    pickedTotal() {
      if (!this.cur) return 0;
      return this.cur.children
        .filter((c) => this.picked.includes(c.studentid) && c.price)
        .reduce((s, c) => s + Number(c.price.total), 0);
    },
  },
  methods: {
    auth() { return { headers: { Authorization: 'Bearer ' + this.$store.getters.getToken } }; },
    dateBadge(d) {
      const dt = new Date(d);
      return { d: dt.getDate(), m: monthShortNames()[dt.getMonth()] };
    },
    regTotal(r) { return Number(r.gym_fee) + Number(r.organizer_fee); },
    // ใบที่หักโควตาคอร์ส (ผู้ปกครองไม่ได้สมัครเอง) ไม่มียอดให้โอน → ไม่แนบสลิป/ไม่ยกเลิกเองจากหน้านี้
    needsPay(r) { return !r.paid && r.quota_mode !== 'deduct'; },
    // ราคาต่ำสุดที่คิดได้ในอีเวนต์นั้น — ใช้โชว์บนการ์ดเมื่อลูกแต่ละคนราคาต่างกัน (โหมดอายุ/level)
    cheapest(ev) {
      const prices = ev.children.filter((c) => c.price).map((c) => Number(c.price.total));
      return prices.length ? Math.min(...prices) : null;
    },
    pickable(c) { return !c.alreadyRegistered && !c.programBlocked && !c.needAdmin && !!c.price; },
    canSignup(ev) { return ev.seatsLeft > 0 && ev.children.some((c) => this.pickable(c)); },
    blockReason(ev) {
      if (ev.seatsLeft <= 0) return this.$t('evSignup.fullHint');
      if (ev.children.every((c) => c.alreadyRegistered)) return this.$t('evSignup.allRegistered');
      return this.$t('evSignup.noEligibleChild');
    },
    dueOfEvent(eventid) {
      return this.myRegs.filter((r) => Number(r.eventid) === Number(eventid) && this.needsPay(r))
        .reduce((s, r) => s + this.regTotal(r), 0);
    },
    pendingNames(eventid) {
      return this.myRegs.filter((r) => Number(r.eventid) === Number(eventid) && this.needsPay(r))
        .map((r) => r.nickname).join(', ');
    },
    async load(silent) {
      if (!silent) this.loading = true;
      try {
        const [open, mine] = await Promise.all([
          axios.post(this.baseURL + '/getOpenEventsForCustomer', {}, this.auth()),
          axios.post(this.baseURL + '/getMyEventRegistrations', {}, this.auth()),
        ]);
        this.openEvents = (open.data && open.data.results) || [];
        this.myRegs = (mine.data && mine.data.results) || [];
      } catch (e) {
        // เงียบเมื่อเป็นการโหลดพื้นหลัง — บล็อกนี้เป็นส่วนเสริมของหน้าแรก ไม่ควรเด้ง error ทับ
        if (!silent) this.openEvents = [];
      } finally {
        this.loading = false;
      }
    },
    openSignup(ev) {
      this.cur = ev; this.picked = []; this.file = null; this.signupDlg = true;
    },
    togglePick(c) {
      if (!this.pickable(c)) return;
      const i = this.picked.indexOf(c.studentid);
      if (i >= 0) this.picked.splice(i, 1); else this.picked.push(c.studentid);
    },
    onFile(e) { this.file = (e.target.files && e.target.files[0]) || null; },
    async submitSignup() {
      if (!this.picked.length) return;
      // ⚠️ ที่นั่งอาจถูกจองไปหมดระหว่างที่ dialog เปิดอยู่ — backend ล็อกแถวอีเวนต์แล้วนับใหม่
      // อีกครั้งเสมอ ตรงนี้เป็นแค่การกันพลาดเบื้องต้น ไม่ใช่ด่านจริง
      if (this.picked.length > this.cur.seatsLeft) {
        this.$emit('onErrorHandler', this.$t('evSignup.notEnoughSeats', { n: this.cur.seatsLeft }));
        return;
      }
      this.saving = true; this.$emit('onLoading', true);
      try {
        const fd = new FormData();
        fd.append('eventid', this.cur.eventid);
        fd.append('studentids', JSON.stringify(this.picked));
        if (this.file) fd.append('slipImage', this.file);
        const r = await axios.post(this.baseURL + '/registerEventByCustomer', fd, this.auth());
        if (r.data && r.data.success) {
          this.signupDlg = false;
          this.$emit('onSuccessHandler', r.data.message);
          await this.load(true);
        } else {
          this.$emit('onErrorHandler', (r.data && r.data.message) || this.$t('common.serverError'));
        }
      } catch (e) {
        this.$emit('onErrorHandler', this.$t('common.serverError'));
      } finally {
        this.saving = false; this.$emit('onLoading', false);
      }
    },
    openPay(r) { this.payTarget = r; this.file = null; this.payDlg = true; },
    async submitSlip() {
      if (!this.file) return;
      this.saving = true; this.$emit('onLoading', true);
      try {
        const fd = new FormData();
        fd.append('eventid', this.payTarget.eventid);
        fd.append('slipImage', this.file);
        const r = await axios.post(this.baseURL + '/uploadEventPaymentSlipByCustomer', fd, this.auth());
        if (r.data && r.data.success) {
          this.payDlg = false;
          this.$emit('onSuccessHandler', r.data.message);
          await this.load(true);
        } else {
          this.$emit('onErrorHandler', (r.data && r.data.message) || this.$t('common.serverError'));
        }
      } catch (e) {
        this.$emit('onErrorHandler', this.$t('common.serverError'));
      } finally {
        this.saving = false; this.$emit('onLoading', false);
      }
    },
    askCancel(r) { this.cancelTarget = r; this.cancelDlg = true; },
    async submitCancel() {
      this.saving = true; this.$emit('onLoading', true);
      try {
        const r = await axios.post(this.baseURL + '/cancelEventRegistrationByCustomer',
          { registrationid: this.cancelTarget.registrationid }, this.auth());
        if (r.data && r.data.success) {
          this.cancelDlg = false;
          this.$emit('onSuccessHandler', r.data.message);
          await this.load(true);
        } else {
          this.$emit('onErrorHandler', (r.data && r.data.message) || this.$t('common.serverError'));
        }
      } catch (e) {
        this.$emit('onErrorHandler', this.$t('common.serverError'));
      } finally {
        this.saving = false; this.$emit('onLoading', false);
      }
    },
  },
  created() { this.load(); },
};
</script>

<style scoped>
/* ⚠️ คลาส home-hist-row / home-datebadge อยู่ใน <style scoped> ของ Home.vue จึงใช้ข้ามคอมโพเนนต์
   ไม่ได้ (scoped = ผูกกับ data-v ของไฟล์นั้น) — รอบแรกยืมมาใช้แล้วแถวไม่มีสไตล์เลย ป้ายลอยหลุดการ์ด
   ที่นี่จึงนิยามของตัวเองด้วยชื่อ ev-* โดยคุมหน้าตาให้ตรงกับแถวในหน้าแรก */
.ev-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 14px; }
.ev-card { padding: 14px; }
.ev-card-head { display: flex; align-items: flex-start; gap: 10px; }
.ev-card-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.ev-card-main .strong { overflow-wrap: break-word; }
.ev-note { margin-top: 8px; white-space: pre-wrap; }
.ev-price { margin-top: 6px; font-weight: 600; }

/* ── แถว "การสมัครของฉัน" ── ป้ายวันที่ | เนื้อหา | (สถานะ + ปุ่ม) ชิดขวา */
.ev-row { display: flex; align-items: flex-start; gap: 12px; padding: 10px 16px; border-bottom: 1px solid var(--c-border); }
.ev-row:last-child { border-bottom: none; }
.ev-row-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.ev-wrap { overflow-wrap: break-word; }
.ev-row-side { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; flex: 0 0 auto; }
.ev-row-actions { display: flex; align-items: center; gap: 6px; }
.ev-btn-danger { color: var(--c-error); }
/* ป้ายวันที่ — สำเนาหน้าตาจาก .home-datebadge ของ Home.vue (คนละ scope ใช้ร่วมกันไม่ได้) */
.ev-date { flex: 0 0 54px; width: 54px; align-self: stretch; display: flex; flex-direction: column;
  align-items: center; justify-content: center; text-align: center;
  background: var(--c-surface-2); border-radius: var(--radius-sm); padding: 6px 0; }
.ev-date-d { display: block; font-family: var(--font-head); font-weight: 700; font-size: 22px; color: var(--c-primary); line-height: 1.1; }
.ev-date-m { display: block; font-size: 11px; color: var(--c-text-muted); letter-spacing: .02em; }

/* จอแคบ: ปุ่มยาวกว่าที่ว่างในแถว → ให้คอลัมน์ขวาตกลงมาเต็มความกว้างแทนที่จะบีบชื่ออีเวนต์จนล้น */
@media (max-width: 560px) {
  .ev-row { flex-wrap: wrap; }
  .ev-row-side { width: 100%; flex-direction: row; justify-content: space-between; align-items: center; }
}

/* ชื่อไฟล์ที่เลือกอาจยาวกว่าช่อง — ตัดด้วย ellipsis ไม่ให้ดันกรอบ .id-upload บาน */
.ev-upload-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ev-pick { display: flex; align-items: center; gap: 10px; padding: 10px 4px; cursor: pointer; border-bottom: 1px solid var(--c-border); }
.ev-pick:last-of-type { border-bottom: 0; }
.ev-pick-off { opacity: .55; cursor: not-allowed; }
.ev-pick-fee { font-weight: 700; white-space: nowrap; }
</style>
